import {storeToRefs} from 'pinia';
import {ProductionTypeIdEnum, useShoppingCartStore} from '~/stores/shoppingCart';
import {slugToBusiness} from '~/utils';

export default defineNuxtRouteMiddleware(({params: {branch, slug}}) => {
	const shoppingCartStore = useShoppingCartStore();
	const {state} = storeToRefs(shoppingCartStore);

	if (typeof branch === 'string' && branch !== state.value.hypermarket) {
		state.value.hypermarket = branch;
		state.value.itemsByBusiness = {
			[ProductionTypeIdEnum.RESTAURANT]: [],
			[ProductionTypeIdEnum.BAKERY]: [],
			[ProductionTypeIdEnum.BUTCHERY]: [],
			[ProductionTypeIdEnum.CATERING]: [],
		};
		// Reset pickup time when switching hypermarket to prevent mismatch between takeoutCounterId and orderItems
		state.value.pickupTime = {
			beginDateTime: null,
			takeoutCounterId: 0,
		};
	}

	if (typeof slug === 'string' && slugToBusiness(slug) !== state.value.currentBusiness) {
		state.value.currentBusiness = slugToBusiness(slug);
	}
});
